import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SStorageService } from '../services/sessionStorage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(private router: Router, private sstorageService: SStorageService) {}

  canActivate(): boolean | UrlTree {
    const token = this.sstorageService.getItem('token');
    if (token && token.length > 0) {
      // Decodifica el JWT y verifica la expiración
      const payload = this.decodeJwtPayload(token);
      if (payload && payload.exp) {
        const expDate = this.expToDate(payload.exp);
        const now = new Date();
        // // console.log('Token expira en:', expDate.toLocaleString());
        // // console.log('Fecha actual:', now.toLocaleString());
        if (expDate > now) {
          return true;
        }
      }
    }
    // Redirige a /error-page con code=401 si no hay token o está expirado
    return this.router.createUrlTree(['/error-page'], { queryParams: { code: 401 } });
  }

  private decodeJwtPayload(token: string): any | null {
    try {
      const payloadBase64 = token.split('.')[1];
      const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decodeURIComponent(escape(payloadJson)));
    } catch (e) {
      return null;
    }
  }

  /**
   * Convierte el campo exp (segundos desde 1970) a un objeto Date
   */
  private expToDate(exp: number): Date {
    return new Date(exp * 1000);
  }
}